export { default as Button } from './Button';
export { default as List } from './List';
export { default as Container } from './Container';
export { default as Label } from './Label';
export { default as FilteredList } from './FilteredList';
export { default as Modal } from './Modal';
export { default as Loading } from './Loading';
export {
  default as Form,
  TextField,
  SelectField,
  RadioField,
  OnOffField,
  FilteredListField,
  TagField,
  FormattedField,
  TimeField,
  ArrayField,
  NonEmptyArrayField,
  validation,
  filterErrors,
  CheckField,
  TextareaField,
  DateField,
  ToggleField,
  PhoneArray,
  EmailArray,
} from './Form';

export function bindMethods(obj, arr) {
  arr.forEach((method) => {
    //  eslint-disable-next-line no-param-reassign
    obj[method] = obj[method].bind(obj);
  });
}
